import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/characters", label: "角色专区" },
  { to: "/works", label: "同人作品" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

const characterLinks = [
  { to: "/characters?c=hinata", label: "日向雏田同人" },
  { to: "/characters?c=sakura", label: "春野樱同人" },
  { to: "/characters?c=tsunade", label: "纲手同人" },
  { to: "/characters?c=sasuke", label: "宇智波佐助同人" },
  { to: "/characters?c=naruto", label: "漩涡鸣人同人" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-700 text-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500">
                <i className="ri-leaf-fill text-lg text-background-50" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                火影<span className="text-primary-300">同人志</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-100">
              专注于火影忍者同人作品的角色分类与内容推荐平台，收录日向雏田、春野樱、纲手、宇智波佐助、漩涡鸣人等人气角色的同人创作，持续更新，陪你回味忍界的每一个动人瞬间。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#footer"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-600/60 text-secondary-50 transition-colors hover:bg-primary-500"
              >
                <i className="ri-weibo-line text-sm" aria-hidden="true"></i>
              </a>
              <a
                href="#footer"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-600/60 text-secondary-50 transition-colors hover:bg-primary-500"
              >
                <i className="ri-bilibili-line text-sm" aria-hidden="true"></i>
              </a>
              <a
                href="#footer"
                aria-label="豆瓣"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-600/60 text-secondary-50 transition-colors hover:bg-primary-500"
              >
                <i className="ri-douban-line text-sm" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-secondary-100 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">人气角色</h3>
            <ul className="mt-4 space-y-3">
              {characterLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-secondary-100 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-secondary-600 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-200">
            © 2026 火影同人志 · 本站为粉丝同人内容分享平台，与原作者及版权方无隶属关系
          </p>
          <p className="text-xs text-secondary-200">用爱发电 · 持续更新</p>
        </div>
      </div>
    </footer>
  );
}